import angular from 'angular';
import parseOrderStage from 'App/resources/parsers/orderStage';

angular.module('upResources').service('ParseOrderStage', [
	function () {
		return parseOrderStage;
	}
]);
